import React from "react";
import { Checkbox,ToggleButton, ToggleButtonGroup, Box, TextField, Card, IconButton, CardMedia, Typography, FormControl, MenuItem, Select, InputLabel, SelectChangeEvent, Slider } from "@mui/material";
import {  Delete as DeleteIcon,  Label,  Upload as UploadIcon, } from "@mui/icons-material";
import { useDropzone } from "react-dropzone";
import {CallToAction, CallToActionOutlined, Layers, LayersOutlined, LayersClearOutlined, LocalFloristOutlined, LocalFlorist, MacroOff} from '@mui/icons-material';
import { useColorMode } from "../ColorModeContext";


interface PromptingPanelProps {
  setPositivePrompt: (value: string) => void;
  setNegativePrompt: (value: string) => void;

  setCyanPrompt: (value: string ) => void;
  cyanPrompt: string;
  setCyanNegative: (value: string ) => void;
  cyanNegative: string;
  cyanReference: string ;
  onDropCyan: (files: File[]) => void;
  handleDeleteReferenceCyan: () => void;
  cyanPromptWeight: number;
  setCyanPromptWeight: (value: number) => void;
  cyanNegativeWeight: number;
  setCyanNegativeWeight: (value: number) => void;
  cyanImgWeight: number;
  setCyanImgWeight: (value: number) => void;

  //handleCheckedColors: (color: string) => (event: React.ChangeEvent<HTMLInputElement>) => void;
  //checkedColors: { cyan: boolean; blue: boolean; lime: boolean; green: boolean; red: boolean; vegetation: boolean; };

  setBluePrompt: (value: string ) => void;
  bluePrompt: string;
  setBlueNegative: (value: string ) => void;
  blueNegative: string;
  blueReference: string ;
  onDropBlue: (files: File[]) => void;
  handleDeleteReferenceBlue: () => void;
  bluePromptWeight: number;
  setBluePromptWeight: (value: number) => void;
  blueNegativeWeight: number;
  setBlueNegativeWeight: (value: number) => void;
  blueImgWeight: number;
  setBlueImgWeight: (value: number) => void;

  setLimePrompt: (value: string ) => void;
  limePrompt: string;
  setLimeNegative: (value: string ) => void;
  limeNegative: string;
  limeReference: string ;
  onDropLime: (files: File[]) => void;
  limePromptWeight: number;
  setLimePromptWeight: (value: number) => void;
  limeNegativeWeight: number;
  setLimeNegativeWeight: (value: number) => void;
  limeImgWeight: number;
  setLimeImgWeight: (value: number) => void;
  handleDeleteReferenceLime: () => void;

  setGreenPrompt: (value: string ) => void;
  greenPrompt: string;
  setGreenNegative: (value: string ) => void;
  greenNegative: string;
  greenReference: string ;
  onDropGreen: (files: File[]) => void;
  greenPromptWeight: number;
  setGreenPromptWeight: (value: number) => void;
  greenNegativeWeight: number;
  setGreenNegativeWeight: (value: number) => void;
  greenImgWeight: number;
  setGreenImgWeight: (value: number) => void;
  handleDeleteReferenceGreen: () => void;

  setRedPrompt: (value: string ) => void;
  redPrompt: string;
  setRedNegative: (value: string ) => void;
  redNegative: string;
  redReference: string ;
  onDropRed: (files: File[]) => void;
  handleDeleteReferenceRed: () => void;
  redPromptWeight: number;
  setRedPromptWeight: (value: number) => void;
  redNegativeWeight: number;
  setRedNegativeWeight: (value: number) => void;
  redImgWeight: number;
  setRedImgWeight: (value: number) => void;

  setVegetationPrompt: (value: string ) => void;
  vegetationPrompt: string;
  setVegetationNegative: (value: string ) => void;
  vegetationNegative: string;
  vegetationReference: string ;
  onDropVegetation: (files: File[]) => void;
  vegetationPromptWeight: number;
  setVegetationPromptWeight: (value: number) => void;
  vegetationNegativeWeight: number;
  setVegetationNegativeWeight: (value: number) => void;
  vegetationImgWeight: number;
  setVegetationImgWeight: (value: number) => void;
  handleDeleteReferenceVegetation: () => void;


  colorState: string;

  atmosphere: string;
  handleAtmosphereChange: (event: SelectChangeEvent) => void;
  style: string;
  handleStyleChange: (event: SelectChangeEvent) => void;
  season: string;
  handleSeasonChange: (event: SelectChangeEvent) => void;
}

const PromptingPanel: React.FC<PromptingPanelProps> = ({
  setPositivePrompt,
  setNegativePrompt,
  atmosphere, 
  handleAtmosphereChange,
  style,
  handleStyleChange,
  season,
  handleSeasonChange,

  //handleCheckedColors,
  //checkedColors,

  cyanReference,
  onDropCyan,
  handleDeleteReferenceCyan,
  setCyanPrompt,
  cyanPrompt,
  cyanPromptWeight,
  cyanNegativeWeight,
  setCyanPromptWeight,
  setCyanNegativeWeight,
  cyanImgWeight,
  setCyanImgWeight,
  cyanNegative,
  setCyanNegative,

  blueReference,
  onDropBlue,
  handleDeleteReferenceBlue,
  setBluePrompt,
  bluePrompt,
  bluePromptWeight,
  blueNegativeWeight,
  setBluePromptWeight,
  setBlueNegativeWeight,
  blueImgWeight,
  setBlueImgWeight,
  blueNegative,
  setBlueNegative,

  limeReference,
  onDropLime,
  handleDeleteReferenceLime,
  setLimePrompt,
  limePrompt,
  limePromptWeight,
  limeNegativeWeight,
  setLimePromptWeight,
  setLimeNegativeWeight,
  limeImgWeight,
  setLimeImgWeight,
  limeNegative,
  setLimeNegative,

  greenReference,
  onDropGreen,
  handleDeleteReferenceGreen,
  setGreenPrompt,
  greenPrompt,
  greenPromptWeight,
  greenNegativeWeight,
  setGreenPromptWeight,
  setGreenNegativeWeight,
  greenImgWeight,
  setGreenImgWeight,
  greenNegative,
  setGreenNegative,

  onDropRed,
  redReference,
  handleDeleteReferenceRed,
  setRedPrompt,
  redPrompt,
  redNegative,
  setRedNegative,
  redPromptWeight,
  setRedPromptWeight,
  redNegativeWeight,
  setRedNegativeWeight,
  redImgWeight,
  setRedImgWeight,

  vegetationReference,
  onDropVegetation,
  handleDeleteReferenceVegetation,
  setVegetationPrompt,
  vegetationPrompt,
  vegetationPromptWeight,
  vegetationNegativeWeight,
  setVegetationPromptWeight,
  setVegetationNegativeWeight,
  vegetationImgWeight,
  setVegetationImgWeight,
  vegetationNegative,
  setVegetationNegative,

  colorState,

}) => {
  const { getRootProps: getRootPropsCyan, getInputProps: getInputPropsCyan } = useDropzone({ onDrop: onDropCyan });
  const { getRootProps: getRootPropsBlue, getInputProps: getInputPropsBlue } = useDropzone({ onDrop: onDropBlue });
  const { getRootProps: getRootPropsLime, getInputProps: getInputPropsLime } = useDropzone({ onDrop: onDropLime });
  const { getRootProps: getRootPropsGreen, getInputProps: getInputPropsGreen } = useDropzone({ onDrop: onDropGreen });
  const { getRootProps: getRootPropsRed, getInputProps: getInputPropsRed } = useDropzone({ onDrop: onDropRed });
  const { getRootProps: getRootPropsVegetation, getInputProps: getInputPropsVegetation } = useDropzone({ onDrop: onDropVegetation });
  const {colorMode} = useColorMode();

  
  const colors: { name: keyof typeof references; borderColor: string }[] = [
    { name: "cyan", borderColor: "#53c0e0" },
    { name: "blue", borderColor: "#12408A" },
    { name: "lime", borderColor: "#C1CF2B" },
    { name: "green", borderColor: "#5FB490" },
    { name: "red", borderColor: "#FF0000" },
    { name: "vegetation", borderColor: "#B3C07F" },
  ];
  
  const references = {
    cyan: cyanReference,
    blue: blueReference,
    lime: limeReference,
    green: greenReference,
    red: redReference,
    vegetation: vegetationReference,
  } as const;
  
  const deleteHandlers = {
    cyan: handleDeleteReferenceCyan,
    blue: handleDeleteReferenceBlue,
    lime: handleDeleteReferenceLime,
    green: handleDeleteReferenceGreen,
    red: handleDeleteReferenceRed,
    vegetation: handleDeleteReferenceVegetation,
  } as const;
  
  const rootProps = {
    cyan: getRootPropsCyan,
    blue: getRootPropsBlue,
    lime: getRootPropsLime,
    green: getRootPropsGreen,
    red: getRootPropsRed,
    vegetation: getRootPropsVegetation,
  } as const;
  
  const inputProps = {
    cyan: getInputPropsCyan,
    blue: getInputPropsBlue,
    lime: getInputPropsLime,
    green: getInputPropsGreen,
    red: getInputPropsRed,
    vegetation: getInputPropsVegetation,
  } as const;
  
  const imgWeights = {
    cyan: cyanImgWeight,
    blue: blueImgWeight,
    lime: limeImgWeight,
    green: greenImgWeight,
    red: redImgWeight,
    vegetation: vegetationImgWeight,
  } as const;
  
  const setImgWeights = {
    cyan: setCyanImgWeight,
    blue: setBlueImgWeight,
    lime: setLimeImgWeight,
    green: setGreenImgWeight,
    red: setRedImgWeight,
    vegetation: setVegetationImgWeight,
  } as const;
  
  const prompts = {
    cyan: cyanPrompt,
    blue: bluePrompt,
    lime: limePrompt,
    green: greenPrompt,
    red: redPrompt,
    vegetation: vegetationPrompt,
  } as const;
  
  const setPrompts = {
    cyan: setCyanPrompt,
    blue: setBluePrompt,
    lime: setLimePrompt,
    green: setGreenPrompt,
    red: setRedPrompt,
    vegetation: setVegetationPrompt,
  } as const;
  
  const negatives = {
    cyan: cyanNegative,
    blue: blueNegative,
    lime: limeNegative,
    green: greenNegative,
    red: redNegative,
    vegetation: vegetationNegative,
  } as const;
  
  const setNegatives = {
    cyan: setCyanNegative,
    blue: setBlueNegative,
    lime: setLimeNegative,
    green: setGreenNegative,
    red: setRedNegative,
    vegetation: setVegetationNegative,
  } as const;
  
  const promptWeights = {
    cyan: cyanPromptWeight,
    blue: bluePromptWeight,
    lime: limePromptWeight,
    green: greenPromptWeight,
    red: redPromptWeight,
    vegetation: vegetationPromptWeight,
  } as const;
  
  const setPromptWeights = {
    cyan: setCyanPromptWeight,
    blue: setBluePromptWeight,
    lime: setLimePromptWeight,
    green: setGreenPromptWeight,
    red: setRedPromptWeight,
    vegetation: setVegetationPromptWeight,
  } as const;

      const [checkedColors, setCheckedColors] = React.useState({
          cyan:       true,
          blue:       false,
          lime:       false,
          green:      false,
          red:        false,
          vegetation: false,
        });
  
  const handleCheckedColors = (color: keyof typeof checkedColors) => () => {
    setCheckedColors(prevState => ({
      cyan: false,
      blue: false,
      lime: false,
      green: false,
      red: false,
      vegetation: false,
      [color]: !prevState[color], // Toggle only the selected color
    }));
  };

  return (
    <div>
      {/* Title */}
      <div style={{marginTop:'30px'}}>
      <div className="Title">
        <h1 className={colorMode?"TopNumberDark":"TopNumberLight"}>2</h1>
        <h1 className="Title">Prompting</h1>
      </div>
      <h4 className="SubTitle">Set the image style and atmosphere</h4>
      </div>
      
      {/* Season */}
      <FormControl required fullWidth sx={{mb:'10px'}}>
            <InputLabel id="season-label">Select season</InputLabel>
            <Select
              label="Select season"
                labelId="season-label"
                id="season"
                value={season}
                onChange={handleSeasonChange}
            >
                <MenuItem value={"spring"}>Spring</MenuItem>
                <MenuItem value={"summer"}>Summer</MenuItem>
                <MenuItem value={"autumn"}>Autumn</MenuItem>
                <MenuItem value={"winter"}>Winter</MenuItem>
            </Select>
      </FormControl>

      {/* Atmosphere */}
      <FormControl required fullWidth sx={{mb:'10px'}}>
            <InputLabel id="atmosphere-label">Select atmosphere</InputLabel>
            <Select
              label="Select atmosphere"
                labelId="atmosphere-label"
                id="atmosphere"
                value={atmosphere}
                onChange={handleAtmosphereChange}
            >
                <MenuItem value={"day"}>Daylight</MenuItem>
                <MenuItem value={"dawn"}>Dawn</MenuItem>
                <MenuItem value={"night"}>Night</MenuItem>
            </Select>
      </FormControl>

      {/* style */}
      <FormControl required fullWidth sx={{mb:'10px'}}>
            <InputLabel id="style-label">Select style</InputLabel>
            <Select
              label="Select style"
                labelId="style-label"
                id="style"
                value={style}
                onChange={handleStyleChange}
            >
                <MenuItem value={"real"}>Realistic</MenuItem>
                <MenuItem value={"picto"}>Pictographic</MenuItem>
                <MenuItem value={"sketch"}>Sketch</MenuItem>
            </Select>
      </FormControl>

      {/* Prompt Inputs 
      <TextField
        placeholder="Custom Prompt"
        label="Positive prompt"
        style={{ marginBottom: "10px" }}
        onChange={(e) => setPositivePrompt(e.target.value)}
        fullWidth
      />
      <TextField
        placeholder="Custom Prompt"
        label="Negative prompt"
        style={{ marginBottom: "10px" }}
        onChange={(e) => setNegativePrompt(e.target.value)}
        fullWidth
      />*/}
{/*onChange={handleCheckedColors("cyan")}*/}
{/*onChange={handleCheckedColors("blue")}*/}
{/*onChange={handleCheckedColors("lime")}*/}
{/*onChange={handleCheckedColors("green")}*/}
{/*onChange={handleCheckedColors("red")}*/}
{/*onChange={handleCheckedColors("vegetation")}*/}
      <Box sx={{display:"flex", flexDirection:"row"}}>
 
        
        <Box sx={{border:colorMode?"1px solid #494949":"1px solid #c1c1c1", borderRadius:"5px", alignContent:"center", flex:"1", pr:"0px", ml:"0px", display:"flex", flexDirection:"row"}}>
        <Checkbox 
  checked={checkedColors.cyan} 
  onChange={handleCheckedColors("cyan")}
  sx={{flex:"1", color:"#53C0E0",'&.Mui-checked': {color: "#53C0E0"}}} 
  icon={<LayersOutlined/>} 
  checkedIcon={<Layers/>} />
<Checkbox 
  checked={checkedColors.blue}  
  onChange={handleCheckedColors("blue")}
  sx={{flex:"1", color:"#12408A",'&.Mui-checked': {color: "#12408A"}}} 
  icon={<LayersOutlined/>} 
  checkedIcon={<Layers/>} 
/>
<Checkbox 
  checked={checkedColors.lime}  
  onChange={handleCheckedColors("lime")}
  sx={{flex:"1", color:"#C1CF2B",'&.Mui-checked': {color: "#C1CF2B"}}} 
  icon={<LayersOutlined/>} 
  checkedIcon={<Layers/>} 
/>
<Checkbox 
  checked={checkedColors.green}  
  onChange={handleCheckedColors("green")}
  sx={{flex:"1", color:"#5FB490",'&.Mui-checked': {color: "#5FB490"}}} 
  icon={<LayersOutlined/>} 
  checkedIcon={<Layers/>} 
/>
<Checkbox 
  checked={checkedColors.red}  
  onChange={handleCheckedColors("red")}
  sx={{flex:"1", color:"#BD4C55",'&.Mui-checked': {color: "#BD4C55"}}} 
  icon={<LayersOutlined/>} 
  checkedIcon={<Layers/>} 
/>
<Checkbox 
  checked={checkedColors.vegetation}  
  onChange={handleCheckedColors("vegetation")}
  sx={{flex:"1", color:"#B3C07F",'&.Mui-checked': {color: "#B3C07F"}}} 
  icon={<LocalFloristOutlined/>} 
  checkedIcon={<LocalFlorist/>} 
/>        </Box>
      </Box>


{/*TODO - update logic inside elements */}

{/* color Prompting */}
{colors.map(({ name, borderColor }) =>
  checkedColors?.[name] && (
    <Box key={name} sx={{ border: `2px solid ${borderColor}`, borderRadius: "10px", p: "5px", mt: "10px" }}>
      <p style={{ margin: 0, marginTop: "10px" }}>{name.charAt(0).toUpperCase() + name.slice(1)} color reference image</p>
      <Card sx={{ width: "100%", mb: 0, position: "relative" }}>
        {references[name] ? (
          <>
            <CardMedia
              component="img"
              image={references[name] || ""}
              alt="Uploaded Image"
              sx={{ maxHeight: "150px", objectFit: "contain" }}
            />
            <IconButton
              onClick={deleteHandlers[name]}
              sx={{
                position: "absolute",
                top: 5,
                right: 5,
                color: "white",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
              }}
            >
              <DeleteIcon />
            </IconButton>
          </>
        ) : (
          <Box
            {...rootProps[name]()}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: 150,
              border: "none",
              borderRadius: 2,
              cursor: "pointer",
              textAlign: "center",
              p: 2,
            }}
          >
            <input {...inputProps[name]()} />
            <UploadIcon fontSize="large" />
            <Typography>Drag & drop an image here, or click to select</Typography>
          </Box>
        )}
      </Card>

      {/* Image Weight Slider */}
      <Box sx={{ flex: "1", pr: "10px", ml: "5px", display: "flex", alignItems: "center" }}>
        <p style={{ marginRight: "5px" }}>Weight:</p>
        <Slider
          value={imgWeights[name]}
          min={0.1}
          max={1}
          step={0.01}
          onChange={(_, value) => setImgWeights[name](value as number)}
        />
        <p style={{ margin: "0px", padding: "0px 0px 0px 10px" }}>{imgWeights[name]}</p>
      </Box>

      {/* Prompt Section */}
      <Box sx={{ mb: "10px", display: "flex", flexDirection: "row" }}>
        <Box sx={{ width: "10px", p: "1px", borderRadius: "5px 0px 0px 5px", backgroundColor: borderColor }} />
        <TextField
          required
          placeholder={`(+) ${name.charAt(0).toUpperCase() + name.slice(1)} color positive prompt`}
          label={`(+) ${name.charAt(0).toUpperCase() + name.slice(1)} color positive prompt`}
          style={{ marginBottom: "0px", marginRight: "10px" }}
          value={prompts[name] || ""}
          onChange={(e) => setPrompts[name](e.target.value)}
          fullWidth
          multiline
          rows={5}
          error={prompts[name] === "" && colorState === "error"}
        />
        <Box sx={{ width: "10px", p: "1px", borderRadius: "5px 0px 0px 5px", backgroundColor: borderColor }} />
        <TextField
          required
          placeholder={`(-) ${name.charAt(0).toUpperCase() + name.slice(1)} color negative prompt`}
          label={`(-) ${name.charAt(0).toUpperCase() + name.slice(1)} color negative prompt`}
          style={{ marginBottom: "0px", marginRight: "10px" }}
          value={negatives[name] || ""}
          onChange={(e) => setNegatives[name](e.target.value)}
          fullWidth
          multiline
          rows={5}
          error={negatives[name] === "" && colorState === "error"}
        />
      </Box>

      {/* Prompt Weight Slider */}
      <Box sx={{ display: "flex" }}>
        <Box sx={{ flex: "1", pr: "10px", ml: "5px", display: "flex", alignItems: "center" }}>
          <p style={{ marginRight: "5px" }}>Weight:</p>
          <Slider
            value={promptWeights[name]}
            min={0.1}
            max={1}
            step={0.01}
            onChange={(_, value) => setPromptWeights[name](value as number)}
          />
          <p style={{ margin: "0px", padding: "0px 0px 0px 10px" }}>{promptWeights[name]}</p>
        </Box>
      </Box>
    </Box>
  )
)}
{/* color Prompting */}


    </div>
    
  );
};

export default PromptingPanel;